import { useEffect } from "react";

import { useReplayStore } from "@/stores/replayStore";
import { useReplayResumeStore } from "@/stores/replayResumeStore";

/**
 * When a resumed replay session finishes loading data (sessionState → "ready"),
 * seek to the stored exit position and pause playback.
 */
export function useReplayResumeSeek() {
  const sessionState = useReplayStore((s) => s.sessionState);

  useEffect(() => {
    if (sessionState !== "ready") return;

    const resumeStore = useReplayResumeStore.getState();
    const seekTs = resumeStore.pendingSeekTimestamp;
    if (seekTs == null) return;

    const replay = useReplayStore.getState();
    replay.seekToTimestamp(seekTs);
    replay.transitionTo("paused");
    resumeStore.setPendingSeek(null);
  }, [sessionState]);
}
